import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/attack';

/** 状況 `attack_direct`（組み立ては `../fx/attack.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'attack_direct', role: 'effect', ...spec }, 'attack_direct_effect.js');
